import { useCallback, useEffect, useRef } from "react";
import { VIDEO_BUFFER } from "constants/constants";
import {
  setBigCamQuality,
  setBigScreenQuality,
  setSmallCamQuality,
  setSmallScreenQuality,
  subscribeToCamera,
  subscribeToScreen,
  unsubscribeToCamera,
  unsubscribeToScreen,
} from "slices/mediaServerSlice";
import { GRID_VIEW, PINNED_CAMERA, PINNED_SHARE } from "slices/spaceMediaSlice";

const useVideoOrganiser = (luid, shouldSeeScreen, shouldSeeCamera, visual) => {
  const camBuffer = useRef(null);
  const screenBuffer = useRef(null);

  useEffect(() => {
    if (shouldSeeCamera) {
      if (visual === PINNED_CAMERA || visual === GRID_VIEW) {
        setBigCamQuality(luid);
      } else {
        setSmallCamQuality(luid);
      }
    }
  }, [shouldSeeCamera, luid, visual]);

  useEffect(() => {
    if (shouldSeeScreen) {
      if (visual === PINNED_SHARE || visual === GRID_VIEW) {
        setBigScreenQuality(luid);
      } else {
        setSmallScreenQuality(luid);
      }
    }
  }, [shouldSeeScreen, luid, visual]);

  const disengageScreen = useCallback(async () => {
    if (screenBuffer.current) {
      clearTimeout(screenBuffer.current);
    }
    unsubscribeToScreen(luid);
    screenBuffer.current = null;
  }, [luid]);

  const engageScreen = useCallback(() => {
    screenBuffer.current = null;
    subscribeToScreen(luid);
  }, [luid]);

  const disengageCamera = useCallback(async () => {
    if (camBuffer.current) {
      clearTimeout(camBuffer.current);
    }
    unsubscribeToCamera(luid);
    camBuffer.current = null;
  }, [luid]);

  const engageCamera = useCallback(() => {
    camBuffer.current = null;
    subscribeToCamera(luid);
  }, [luid]);

  useEffect(() => {
    if (shouldSeeScreen) {
      if (!screenBuffer.current) {
        screenBuffer.current = setTimeout(() => {
          engageScreen();
        }, VIDEO_BUFFER);
      }
    } else {
      disengageScreen();
    }
  }, [shouldSeeScreen, engageScreen, disengageScreen]);

  useEffect(() => {
    if (shouldSeeCamera) {
      if (!camBuffer.current) {
        camBuffer.current = setTimeout(() => {
          engageCamera();
        }, VIDEO_BUFFER);
      }
    } else {
      disengageCamera();
    }
  }, [shouldSeeCamera, engageCamera, disengageCamera]);

  useEffect(() => {
    return () => {
      disengageCamera();
      disengageScreen();
    };
  }, [disengageCamera, disengageScreen]);
};
export default useVideoOrganiser;
